/* =================== LATERAL =================== */
jQuery(document).ready(function ($) {
  $(".subcategoria-icone").each(function (index) {
    $(this).on("click mouseenter", function (e) {
      if ($(".subcategoria").eq(index).hasClass("ocultado")) {
        $(".subcategoria").eq(index).slideDown().removeClass("ocultado");
        $(".mais", this).toggleClass("aberto fechado");
      } else {
        if (e.type != "mouseenter") {
          $(".mais", this).toggleClass("aberto fechado");
          $(".subcategoria").eq(index).slideUp().addClass("ocultado");
        }
      }
    });
  });
});
